import React, { useLayoutEffect, useState } from 'react';
import styled from 'styled-components';
import { Link, navigate } from 'gatsby';
import { Menu } from 'amphitheatre';
import { Location } from '@reach/router';

import LogoImg from '../../images/mainlogo.png';

const topStyle: React.CSSProperties = {
  background: 'transparent',
  position: 'fixed',
  top: 0,
  transition: 'background 250ms ease-in',
  width: '100vw',
  zIndex: 1200,
};

const movedStyle: React.CSSProperties = {
  position: 'fixed',
  top: 0,
  transition: 'background 250ms ease-in',
  width: '100vw',
  zIndex: 1200,
};

const Logo = styled.img`
  height: 48px;
  padding: 0.5rem;
`;

const MenuWrapper = styled.div`
  transition: all 500ms ease-in;

  &.hidden {
    transform: translateY(-80px);
  }
`;

interface Props {
  hidden?: boolean;
}

const MenuComponent: React.FunctionComponent<Props> = ({ hidden }: Props) => {
  const [notTop, setNotTop] = useState(false);

  function onMenuClick(id: string): void {
    if (id === 'tarot') {
      return;
    }
    navigate(`/${id}`);
  }

  useLayoutEffect(() => {
    function changeMenu(): void {
      const winScroll =
        document.body.scrollTop || document.documentElement.scrollTop;

      const height =
        document.documentElement.scrollHeight -
        document.documentElement.clientHeight;

      const scrolled = winScroll / height;

      console.log(scrolled);

      if (scrolled !== 0) {
        setNotTop(true);
      } else {
        setNotTop(false);
      }
    }

    window.addEventListener('scroll', changeMenu);
    return (): void => window.removeEventListener('scroll', changeMenu);
  }, []);

  return (
    <Location>
      {(locationProps): JSX.Element => (
        <MenuWrapper className={hidden ? 'hidden' : ''}>
          <Menu
            activeId={locationProps.location.pathname.substr(1)}
            className={notTop ? 'not-top-menu' : 'top-menu'}
            cover
            imgObj={
              <Link to="/" aria-label="Navigate to index page">
                <Logo src={LogoImg} />
              </Link>
            }
            onMenuClick={onMenuClick}
            style={notTop ? movedStyle : topStyle}
          >
            <Menu.Item to="aboutus">About Us</Menu.Item>
            <Menu.Item to="howitworks">How It Works</Menu.Item>
            <Menu.Item to="startups">Startups</Menu.Item>
            <Menu.Item to="memberservices">Member Services</Menu.Item>
            <Menu.Item to="engineeringservices">Engineering Services</Menu.Item>
            <Menu.Item to="facilities">Facilities</Menu.Item>
            <Menu.Item to="contactus">Contact Us</Menu.Item>
          </Menu>
        </MenuWrapper>
      )}
    </Location>
  );
};

export default MenuComponent;
